import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a7d0899bedae700148f5604_1786595240816_af01dd79/usapeptidepros/src/app/suppliers-directory/components/SuppliersDirectoryContent.tsx");
